import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import './Statistics.css';

const StatCard = ({ icon, target, label, prefix = '', suffix = '' }) => {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: true
  });

  useEffect(() => {
    if (inView) {
      const duration = 2000;
      const increment = target / (duration / 16);
      let current = 0;

      const timer = setInterval(() => {
        current += increment;
        if (current < target) {
          setCount(Math.floor(current));
        } else {
          setCount(target);
          clearInterval(timer);
        }
      }, 16);

      return () => clearInterval(timer);
    }
  }, [inView, target]);

  return (
    <div className="stat-card" ref={ref}>
      <div className="stat-icon-circle">{icon}</div>
      <div className="stat-number">
        {prefix}{count.toLocaleString()}{suffix}
      </div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

const Statistics = () => {
  return (
    <section className="statistics" id="statistics">
      <div className="container">
        <h3 className="section-header">GLOBAL OPPORTUNITY</h3>
        <h2 className="section-title">
          THE WORLD FACES AN <span className="title-highlight">ACUTE PILOT SHORTAGE</span>
        </h2>
        <p className="section-subtitle">
          Boeing's 2024 Outlook projects massive demand for pilots globally. This is your chance to enter one of the highest-paying careers with guaranteed employment opportunities.
        </p>
        
        <div className="stats-grid">
          <StatCard 
            icon="✈"
            target={649000}
            label="NEW PILOTS NEEDED GLOBALLY"
          />
          <StatCard 
            icon="🌐"
            target={123000}
            label="PILOTS NEEDED IN NORTH AMERICA"
          />
          <StatCard 
            icon="$"
            target={198100}
            label="MEDIAN US PILOT SALARY ($)"
          />
          <StatCard 
            icon="📈"
            target={95}
            suffix="%"
            label="GRADUATE PLACEMENT RATE"
          />
        </div>

        <p className="source-citation">
          Source: Boeing 2024-2043 Pilot & Technician Outlook, US Bureau of Labor Statistics
        </p>
      </div>
    </section>
  );
};

export default Statistics;
